import { render, staticRenderFns } from "./StoreTypeManagement.vue?vue&type=template&id=07d2200d&"
import script from "./StoreTypeManagement.vue?vue&type=script&lang=js&"
export * from "./StoreTypeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTd,QBtn,QPagination,QDialog,QCard,QCardSection,QCardActions,QInnerLoading,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTd,QBtn,QPagination,QDialog,QCard,QCardSection,QCardActions,QInnerLoading})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
